import * as isEqual from 'fast-deep-equal';
import { ApolloLink, Observable } from '@apollo/client';
class MockLink extends ApolloLink {
    constructor() {
        super(...arguments);
        this.mockHandlers = [];
    }
    request(operation, forward) {
        var _a;
        const handler = this.findHandler(operation);
        if (!handler) {
            return (_a = forward === null || forward === void 0 ? void 0 : forward(operation)) !== null && _a !== void 0 ? _a : null;
        }
        const { type, data, state } = handler;
        const response = typeof data === 'function'
            ? data(operation, state)
            : data;
        return new Observable((observer) => {
            Promise.resolve(response).then((value) => {
                type === 'success'
                    ? observer.next({ data: value })
                    : observer.error(value);
                observer.complete();
            });
        });
    }
    addHandler(handler) {
        this.mockHandlers.push(handler);
    }
    findHandler(operation) {
        var _a;
        const query = (_a = operation.query.loc) === null || _a === void 0 ? void 0 : _a.source.body;
        const { variables } = operation;
        return this.mockHandlers.find((handler) => handler.query === query && this.isEqualVariables(handler.variables, variables));
    }
    isEqualVariables(source, target) {
        if (!source)
            return true;
        return isEqual(source, target);
    }
}
export class ApolloMockAdapter {
    constructor(client) {
        this.client = client;
        this.mockLink = new MockLink();
        this.originalLink = client.link;
        this.client.setLink(this.mockLink.concat(client.link));
    }
    onQuery(query, variables) {
        var _a;
        const _query = typeof query === 'string' ? query : (_a = query.loc) === null || _a === void 0 ? void 0 : _a.source.body;
        if (!_query) {
            throw new Error('query または mutation がありませんでした。');
        }
        return {
            reply: (response, state) => {
                this.mockLink.addHandler({
                    query: _query,
                    variables,
                    type: 'success',
                    data: response,
                    state,
                });
                return this;
            },
            error: (error, state) => {
                this.mockLink.addHandler({
                    query: _query,
                    variables,
                    type: 'error',
                    data: error,
                    state,
                });
                return this;
            },
        };
    }
    onMutate(mutation, variables) {
        return this.onQuery(mutation, variables);
    }
    restore() {
        this.client.setLink(this.originalLink);
    }
}
//# sourceMappingURL=ApolloMockAdapter.js.map